import { inject } from '@angular/core';
import {
  HttpInterceptorFn,
  HttpErrorResponse,
} from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.token(); // Get the token signal's value

  // 1. CLONE THE REQUEST AND ADD THE AUTH HEADER (if token exists)
  // We only want to add the token for our own API calls, not to 3rd party APIs.
  // This check can be made more robust (e.g., by checking req.url.startsWith(environment.apiUrl))
  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  // 2. PASS THE MODIFIED REQUEST AND HANDLE RESPONSES
  return next(req).pipe(
    catchError((error: any) => {
      // We only care about HttpErrorResponse
      if (error instanceof HttpErrorResponse) {
        // 3. HANDLE 401 UNAUTHORIZED ERRORS
        if (error.status === 401) {
          console.error('Unauthorized request. Logging out.', error);
          // This is a critical failure. The user's session is invalid.
          // Log them out and redirect to the login page.
          authService.logout();
          // The router.navigate inside logout() will handle the redirect.
        }

        // Optional: Handle other errors like 403 Forbidden, 500 Server Error, etc.
        // if (error.status === 403) { ... }
      }

      // Re-throw the error so it can be caught by the calling service if needed
      return throwError(() => error);
    })
  );
};